<template>
 <div class="field">
    <div class="control">
        <div>
            <input
                @change="$emit('input', Boolean($event.target.checked))"
                :checked="value"
                :id="id"
                type="checkbox"/>
            <label :for="id">
                <slot/>
            </label>
        </div>
        <p class="help">
            <slot name="description" />
        </p>
    </div>
</div>
</template>

<script>
import { createRandomString } from '@shared/utils'

export default {
    name: 'Checkbox',
    props: {
        value: Boolean,
    },
    data: () => ({
        id: createRandomString()
    }),
}
</script>
